import { UPDATE_BUSINESS_INFO_MODAL_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/UPDATE_BUSINESS_INFO_MODAL_SEEN";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { route as checkoutSuccessRoute } from "@faire/web-api--source/routes/www/checkout/success/orderToken";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useRetailerMilestone } from "@faire/web/common/hooks";
import { matchPathWithLocale } from "@faire/web/common/routing/react-utils";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useUpdateBusinessInfoGate: IGateHook = () => {
  const modalType = useModalType();
  const { hasOccurred: hasSeenUpdateBusinessInfoModal } = useRetailerMilestone(
    UPDATE_BUSINESS_INFO_MODAL_SEEN
  );
  if (
    !hasSeenUpdateBusinessInfoModal &&
    !!matchPathWithLocale(
      getWindowOrThrow().location.pathname,
      checkoutSuccessRoute
    ) &&
    modalType === PromoModalType.UPDATE_BUSINESS_INFO_MODAL
  ) {
    return PromoModalType.UPDATE_BUSINESS_INFO_MODAL;
  }

  return undefined;
};
